import type { TOC } from '@ember/component/template-only';
import HotelPricingAssistantModalsBulkUpdateModal from 'lumen/components/hotel/pricing-assistant/modals/bulk-update-modal';
import type HotelPricingManagerBulkUpdateController from 'lumen/controllers/hotel/pricing-manager/bulk-update';

interface HotelPricingManagerBulkUpdateSignature {
  Args: {
    controller: HotelPricingManagerBulkUpdateController;
    model: unknown;
  };
}

<template>
  <HotelPricingAssistantModalsBulkUpdateModal
    @bulkEndDate={{@controller.bulkEndDate}}
    @bulkStartDate={{@controller.bulkStartDate}}
    @model={{@controller.model}}
    @onClose={{@controller.closeModal}}
    @updateQueryParams={{@controller.updateQueryParams}}
  />
</template> satisfies TOC<HotelPricingManagerBulkUpdateSignature>;
